"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMenuScheduleCollisionWithPrevious = exports.isCurrentMenuScheduleHaveCollision = exports.mapMenuScheduleToMenuScheduleModel = exports.DAYS_IN_WEEK = void 0;
const domain_1 = require("@oolio-group/domain");
const lodash_1 = require("lodash");
exports.DAYS_IN_WEEK = [
    domain_1.DayOfWeek.MONDAY,
    domain_1.DayOfWeek.TUESDAY,
    domain_1.DayOfWeek.WEDNESDAY,
    domain_1.DayOfWeek.THURSDAY,
    domain_1.DayOfWeek.FRIDAY,
    domain_1.DayOfWeek.SATURDAY,
    domain_1.DayOfWeek.SUNDAY,
];
const range = (min, max) => {
    return { min, max };
};
const allIntersect = (...ranges) => {
    // Create separate arrays for the min and max values.
    const minimums = ranges.map(r => r.min);
    const maximums = ranges.map(r => r.max);
    // Extract the comparands.
    const maximalMinimum = Math.max(...minimums);
    const minimalMaximum = Math.min(...maximums);
    return maximalMinimum <= minimalMaximum;
};
const someIntersect = (...ranges) => {
    return ranges.some((range1, index1) => {
        // Compare all ranges to all other ranges.
        return ranges.some((range2, index2) => {
            // Do not compare a range to itself.
            if (index1 === index2) {
                return false;
            }
            return allIntersect(range1, range2);
        });
    });
};
const getTimeRangeDaysTimes = (timeBlock) => {
    const days = timeBlock.days.includes(domain_1.DayOfWeek.ALL)
        ? exports.DAYS_IN_WEEK
        : timeBlock.days;
    const times = [
        Number(timeBlock.timeSlot.startTime.split(':').join('')),
        Number(timeBlock.timeSlot.endTime.split(':').join('')),
    ];
    return [days, times];
};
const getScheduleDateRange = (dateRange) => {
    return [
        (dateRange === null || dateRange === void 0 ? void 0 : dateRange.startDate) || Date.now() - 1000,
        (dateRange === null || dateRange === void 0 ? void 0 : dateRange.endDate) || Date.now() + 1000,
    ];
};
const mapMenuScheduleToMenuScheduleModel = (menuSchedule) => {
    return {
        ...menuSchedule,
        salesChannels: menuSchedule.salesChannels.map(salesChannel => salesChannel.id),
        stores: menuSchedule.stores.map(store => store.id),
        orderTypes: menuSchedule.orderTypes.map(orderType => orderType.id),
    };
};
exports.mapMenuScheduleToMenuScheduleModel = mapMenuScheduleToMenuScheduleModel;
const isCurrentMenuScheduleHaveCollision = (menuSchedule) => {
    for (let i = 0; i < menuSchedule.schedules.length; i++) {
        const schedule = menuSchedule.schedules[i];
        const timeSchedule = getScheduleDateRange(schedule.dateRange);
        if (schedule.timeBlocks.length > 1) {
            for (let q = 0; q < schedule.timeBlocks.length; q++) {
                const timeBlock = schedule.timeBlocks[q];
                const [days, times] = getTimeRangeDaysTimes(timeBlock);
                for (let k = q + 1; k < schedule.timeBlocks.length; k++) {
                    const curTimeBlock = schedule.timeBlocks[k];
                    const [curDays, curTimes] = getTimeRangeDaysTimes(curTimeBlock);
                    if (Boolean((0, lodash_1.intersection)(days, curDays).length) &&
                        someIntersect(range(times[0], times[1] - 1), range(curTimes[0], curTimes[1] - 1))) {
                        return true;
                    }
                }
            }
        }
        if (menuSchedule.schedules.length > 1) {
            for (let j = i + 1; j < menuSchedule.schedules.length; j++) {
                const curSchedule = menuSchedule.schedules[j];
                const curTimeSchedule = getScheduleDateRange(curSchedule.dateRange);
                if (someIntersect(range(timeSchedule[0], timeSchedule[1] - 1), range(curTimeSchedule[0], curTimeSchedule[1] - 1))) {
                    for (const timeBlock of schedule.timeBlocks) {
                        const [days, times] = getTimeRangeDaysTimes(timeBlock);
                        for (const curTimeBlock of curSchedule.timeBlocks) {
                            const [curDays, curTimes] = getTimeRangeDaysTimes(curTimeBlock);
                            if (Boolean((0, lodash_1.intersection)(days, curDays).length) &&
                                someIntersect(range(times[0], times[1] - 1), range(curTimes[0], curTimes[1] - 1))) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
    }
    return false;
};
exports.isCurrentMenuScheduleHaveCollision = isCurrentMenuScheduleHaveCollision;
const isMenuScheduleCollisionWithPrevious = (menuScheduleModel, previousMenuSchedules) => {
    const clasesMenuSchedule = [];
    let isClashes = false;
    for (const prevMenuSchedule of previousMenuSchedules) {
        if (!prevMenuSchedule.isActive)
            continue;
        const prevMenuScheduleModel = (0, exports.mapMenuScheduleToMenuScheduleModel)(prevMenuSchedule);
        const isSalesChannelCollide = Boolean((0, lodash_1.intersection)(menuScheduleModel.salesChannels, prevMenuScheduleModel.salesChannels).length);
        const isStoresCollide = Boolean((0, lodash_1.intersection)(menuScheduleModel.stores, prevMenuScheduleModel.stores)
            .length);
        const isOrderTypesCollide = Boolean((0, lodash_1.intersection)(menuScheduleModel.orderTypes, prevMenuScheduleModel.orderTypes).length);
        const isDateCollide = (function () {
            for (const schedule of menuScheduleModel.schedules) {
                const timeSchedule = getScheduleDateRange(schedule.dateRange);
                for (const curSchedule of prevMenuScheduleModel.schedules) {
                    const curTimeSchedule = getScheduleDateRange(curSchedule.dateRange);
                    if (someIntersect(range(timeSchedule[0], timeSchedule[1]), range(curTimeSchedule[0], curTimeSchedule[1]))) {
                        for (const timeBlock of schedule.timeBlocks) {
                            const [days, times] = getTimeRangeDaysTimes(timeBlock);
                            for (const curTimeBlock of curSchedule.timeBlocks) {
                                const [curDays, curTimes] = getTimeRangeDaysTimes(curTimeBlock);
                                if (Boolean((0, lodash_1.intersection)(days, curDays).length) &&
                                    someIntersect(range(times[0], times[1]), range(curTimes[0], curTimes[1]))) {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
            return false;
        })();
        if (isSalesChannelCollide &&
            isStoresCollide &&
            isOrderTypesCollide &&
            isDateCollide) {
            isClashes = true;
            clasesMenuSchedule.push(prevMenuSchedule.id);
        }
    }
    return { isClashes, clashesMenus: clasesMenuSchedule };
};
exports.isMenuScheduleCollisionWithPrevious = isMenuScheduleCollisionWithPrevious;
//# sourceMappingURL=menuScheduleHelper.js.map